import { ChevronDown, Users, X } from "lucide-react";
import React from "react";

const DashboardHeader = ({
  agentDropdownRef,
  selectedAgent,
  setAgentDropdownOpen,
  handleAgentSelect,
  agentDropdownOpen,
  agents,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-xl font-bold">Dashboard</h1>
        <p className="text-sm text-muted-foreground">Leads Statistics</p>
      </div>
      <div className="relative" ref={agentDropdownRef}>
        <button
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border transition-all shadow-sm ${
            selectedAgent
              ? "bg-[#00a8b4] text-white border-[#00a8b4]"
              : "bg-white text-slate-600 border-slate-200"
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setAgentDropdownOpen((v) => !v);
          }}
        >
          <Users size={14} />
          <span className="max-w-[80px] truncate">
            {selectedAgent ? selectedAgent.name : "All Agents"}
          </span>
          {selectedAgent ? (
            <X
              size={12}
              onClick={(e) => {
                e.stopPropagation();
                handleAgentSelect(null);
              }}
            />
          ) : (
            <ChevronDown size={12} />
          )}
        </button>
        {agentDropdownOpen && (
          <div className="absolute right-0 p-10 z-50 w-52 mt-2 bg-white border border-slate-200 rounded-xl shadow-xl py-1 max-h-72 overflow-y-auto">
            <button
              className={`w-full text-left px-4 py-2.5 text-sm hover:bg-slate-50 transition-colors ${!selectedAgent ? "font-semibold text-[#00a8b4]" : "text-slate-700"}`}
              onClick={(e) => {
                e.stopPropagation();
                handleAgentSelect(null);
              }}
            >
              All Agents
            </button>
            {agents.length > 0 && (
              <div className="border-t border-slate-100 my-1" />
            )}
            {agents.map((agent) => (
              <button
                key={agent.id}
                className={`w-full text-left px-4 py-2.5 text-sm hover:bg-slate-50 transition-colors ${selectedAgent?.id === agent.id ? "font-semibold text-[#00a8b4]" : "text-slate-700"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAgentSelect(agent);
                }}
              >
                {agent.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardHeader;
